export const BaseUrl = "https://javohirgroup.uz/api";
//export const BaseUrl = "https://lyquimoly.uz/api";

export const narxlar = {
  val: true,
  som: true,
  perech: true,
};
